export const LAZY_COMPONENTS = {
    TESTIMONIALS: 'testimonials',
    FIVERR_BUSINESS: 'fiverr_business',
    FIVERR_GUIDES: 'fiverr_guides',
    SIGNUP: 'signup',
    VIDEO: 'video',
    FREELANCERS: 'freelancers',
    PRO_SERVICES: 'pro_services',
    LOGO_MAKER_BANNER: 'logo_maker_banner',
    PERSONALIZED_SECTION_WRAPPER: 'personalized_section_wrapper',
    PRO_BANNER: 'pro_banner',
};

export const LOGGED_OUT_HOMEPAGE_ENTRY_NAMES = {
    LOCALIZED: 'logged_out_homepage_localized',
    MAIN: 'logged_out_homepage',
};
